export const es = {
  Global: {
    save: 'Salvar',
    savingInProgress: 'Saving in progress ES',
    edit: 'Editar',
    amend: 'Amend ES',
    editProposal: 'Edit proposal ES',
    delete: 'Borrar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    proceed: 'Proceder',
    assign: 'Asignar',
    submit: 'Enviar',
    accepted: 'Aceptado',
    denied: 'Denegado',
    deny: 'Negar',
    done: 'Hecho',
    comment: 'Comentario',
    notDone: 'No realizado',
    started: 'Iniciado',
    notRelevant: 'Irrelevante',
    noInfo: 'Sin información',
    addComment: 'Agregar comentario',
    noComments: 'Sin comentarios',
    start: 'Día de inicio',
    end: 'Día de finalización',
    pending: 'Pendiente',
    approve: 'Aprobar',
    approved: 'Aprobado',
    notApproved: 'No aprovado',
    release: 'Liberar',
    released: 'Liberado',
    notReleased: 'No liberado',
    reopen: 'Reabrir',
    requestedBy: 'Solicitado por',
    requestedAt: 'Solicitado en',
    proposedDecision: 'Decisión propuesta',
    proposedCategory: 'Categoría propuesta',
    proposedSubcategory: 'Subcategoría propuesta',
    search: 'Buscar',
    noResults: 'No hay resultados',
    upload: 'Cargar',
    uploading: 'Cargando',
    noFilesUploaded: 'No archivos cargados',
    close: 'Cerrado',
    back: 'Atrás',
    next: 'Siguiente',
    unknown: 'Desconocido',
    from: 'desde',
    to: 'a',
    logout: 'Cerrar sesión',
    profile: 'Perfil',
    group: 'Grupo',
    code: 'Código',
    confirmationDialogTitle: 'Confirmación necesaria',
    confirmDeleteFileDialogContent: '¿Seguro que desea eliminar este archivo?',
    report: 'informe',
    unsavedAnswers: 'Tiene respuestas no guardados. Al confirmar perderá todos los datos no guardados.',
    unsavedAnswersActionMode: 'Tiene respuestas sin guardar. ¿Desea guardarlas?',
    noOptions: 'Sin opciones',
    actionMode: 'Modo de acción',
    reason: 'Razón',
    optional: 'Opcional',
    choose: 'Escoger',
    serialNumberMissing: 'Serial number missing ES',
    recipientEmails: 'Recipient Emails (one address per line) ES',
    DatePicker: {
      cancelLabel: 'Cancelar',
      okLabel: 'OK',
      minDateMessage: 'La fecha no debe ser  antes del 1ro de Enero 1900',
      maxDateMessage: 'La fecha no debe ser posterior a la fecha de hoy',
      invalidDateMessage: 'Formato de fecha incorrecto',
    },
    Errors: {
      authErrorTitle: '¡Error de autenticación!',
      authErrorParagraph1: 'No tiene permisos para acceder a esta aplicación.',
      authErrorParagraph2: 'Por favor, póngase en contacto con su administrador.',
      authErrorParagraph3: 'O cierre de sesión de Directorio Activa y vuelve a intentarlo.',
      pageNotFound: 'Página no encontrada',
      pageNotFoundParagraph1: 'No podemos encontrar esta página',
      back: 'Página de inicio',
      rotateDevice: 'Por favor gire su dispositivo.',
    },
    Feedback: {
      error: 'Algo salió mal ... Acción fallida.',
      authentication: 'Autentificando ... Por favor, espere',
      success: 'Acción completada con éxito',
      limitReached: 'Llímite de decisión comercial alcanzado.',
      requestHasBeenSentToApprover: 'La solicitud ha sido enviada al aprobador correspondiente.',
      noQuestions: 'No hay preguntas para la familia de productos seleccionados.',
      decisionNotSend: 'La decisión no se envió con éxito a SAP.',
      noLimitForCC: 'Usted no tiene establecido  límite  para este centro de servicio  al cliente.',
      jobCostDoesNotExist:'El costo del trabajo en SAP no existe en la base de datos de PARS.',
      materialNumberBrandDoesNotExist: 'Número de material no existe.',
      jobIsLocked: 'El trabajo está bloqueado.',
      noPicturesAreUploaded: 'No hay imágenes cargadas',
      rateIsProvided: 'La calificación se ha registrado correctamente',
      rateHasToBeDifferent: 'La decisión de la calificación debe ser diferente a la anterior',
    },
    Status: {
      title: 'Estado',
      awaitingEquipment: 'En espera de equipos',
      equipmentReceivedWithDocumentation: 'Equipo con la documentación recibida',
      jobReleased: 'trabajo publicado',
      productEvaluation: 'producto evaluado',
      strippedAndDecontaminated: 'Desmantelado y descontaminado',
      builtAndTested: 'Construido y probado',
      shipped: 'Enviado',
      technicalAndCommercialDecision: 'Decisión técnica y comercial',
      finalReportReleased: 'Informe final publicado',
      closed: 'Cerrado',
      productInvestigation: 'Investigación  de producto',
      customerHold: 'Retención del cliente',
      notStarted: 'No empezado',
    },
    Roles: {
      RECEIVING: 'Operador de almacén',
      SERVICE_ENGINEER: 'Ingeniero de servicio',
      FAILURE_ANALYSIS_ENGINEER: 'Ingeniero de análisis de fallos',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: 'Ingeniero de análisis de fallos senior',
      FAILURE_ANALYSIS_MANAGER: 'Gerente de análisis de fallos',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: 'Gerente de  Centro de Servicio de Tecnología ',
      QUALITY_MANAGER: 'Gerente de Calidad',
      SERVICE_TECHNICAL_SUPPORT_TEAM: 'Equipo  de soporte técnico de servicio',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'Equipo de soporte técnico  de empresa de productos',
      DIVISION_OR_BUSINESS_AREA: 'División o área de negocio',
      CUSTOMER_CENTER: 'Centro de Atención al Cliente',
      CUSTOMER: 'Cliente',
      CUSTOMER_CENTER_SERVICE_ENGINEER: 'Ingeniero de centro deservicio al cliente ',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer ES',
      SUPERADMIN: 'Superadmin',
      ZONE_LEADER: 'Líder de zona',
      QUESTION_ADMIN: 'Administrador de pregunta',
      DISTRIBUTOR: 'Distribuidor',
    },
    Permissions: {
      VIEW_JOB: 'Ver trabajo',
      EDIT_JOB: 'Editar trabajo',
      IMPORT_JOB_FROM_SAP: 'Importar trabajo de  SAP',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: 'Nivel 3 de liberación para la investigación',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: 'Nivel 4 liberación para la investigación',
      GENERATE_AND_DOWNLOAD_REPORT: 'Generar y descargar informe',
      VIEW_LOG: 'Ver registro',
      VIEW_CONVERSATION: 'Ver conversación',
      PARTICIPATE_IN_CONVERSATION: 'Participar en la conversación',
      TAG_INTEREST: 'Tagear  interés',
      ADD_REMOVE_FROM_TEAM: 'Agregar y quitar del equipo',
      CREATE_JOB: 'Crear trabajo',
      DELETE_JOB: 'eliminar trabajo',
      REQUEST_DIFFERENT_REPORT_LEVEL: 'Solicitar diferente nivel de informe',
      APPROVE_DIFFERENT_REPORT_LEVEL: 'Aprobar diferente nivel de informe',
      WARRANTY_DECISION: 'Decisión de garantía',
      GOODWILL_DECISION: 'Decisión de buena voluntad',
      LEVEL_1_REPORT_APPROVAL: 'Aprobación de informe Nivel 1',
      LEVEL_2_REPORT_APPROVAL: 'Aprobación de informe Nivel ',
      LEVEL_3_REPORT_APPROVAL: 'Aprobación de informe Nivel 3',
      LEVEL_4_REPORT_APPROVAL: 'Aprobación de informe Nivel 4',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen ES',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen ES',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen ES',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen ES',
      REOPEN_REPORT: 'Reabrir el informe',
      REQUEST_FAILED_PARTS: 'Requisisión de piezas fallidas',
      SHIP_FAILED_PARTS: 'Envío de piezas fallidas',
      PRINT_INPUT_SHEETS: 'Imprimir hojas de entrada',
      ADMINISTRATE_QUESTIONS: 'Administrar preguntas',
      ADMINISTRATE_DATA: 'Administrar datos',
      DOWNLOAD_PICTURES: 'Download pictures ES',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission ES',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision ES',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision ES',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code ES',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category ES',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade ES',
    },
    Alerts: {
      noAlerts: 'No hay alertas',
      healthAndSafetyInformationMissing: 'Información sobre salud y seguridad faltante',
      jobNotReleased: 'Trabajo no liberado',
      noRecentStatusChange: 'Sin cambio de estatus reciente',
      noServiceTechnicalSupportInvolvement: 'Sin soporte técnico de servicio involucrado aun',
      noProductCompanyTechnicalSupportInvolvement: 'Sin soporte técnico de la compañía de producto involucrado aun',
      noTechnicalWarrantyDecision: 'Ninguna decisión técnica de garantía',
      noCommercialDecision: 'Ninguna decisión comercial',
      reportNotApproved: 'Informe no aprobado',
    },
    Actions: {
      ADD_JOB: 'Trabajo añadido',
      IMPORT_JOB: 'Trabajo importado de SAP',
      DELETE_JOB: 'Trabajo borrado',
      VERIFY_JOB: 'Trabajo verificado',
      SET_PRICE: 'Trabajo editado - Costo',
      ADD_TEAM_MEMBER: 'Miembro de equipo añadido',
      REMOVE_TEAM_MEMBER: 'Miembro de equipo eliminado',
      REQUEST_REPORT_LEVEL_CHANGE: 'Cambio de nivel de informe solicitado',
      APPROVE_REPORT_LEVEL_CHANGE: 'Cambio de nivel de informe solicitado',
      DENY_REPORT_LEVEL_CHANGE: 'Cambio de nivel de informe solicitado',
      REQUEST_REPORT_APPROVAL: 'Aprobación informe solicitado',
      APPROVE_REPORT_APPROVAL: 'Aprobación informe aprobado',
      DENY_REPORT_APPROVAL: 'Aprobación Informe negado',
      SET_WARRANTY_START_DATE: 'trabajo editado - Garantía fecha de inicio',
      SET_WARRANTY_END_DATE: 'Trabajo editado - Garantía fecha de finalización',
      EQUIPMENT_SERIAL_NUMBER_EDITED: 'Trabajo editado - número de serie del equipo',
      MATERIAL_NUMBER_EDITED: 'Trabajo editado - Número de material',
      WORKED_ON_JOB: 'Trabajo editado - Pregunta actualizada',
      UPLOADED_FILE_ON_JOB: 'Trabajo editado - Carga de un archivo',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Decisión de garantía técnica solicitada',
      APPROVE_TECHNICAL_WARRANTY_DECISION: 'Decisión de garantía técnica aprobada',
      DENY_TECHNICAL_WARRANTY_DECISION: 'Decisión de garantía técnica negado',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: 'Decisión garantía comercial aprobado',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: 'Decisión garantía comercial anulado',
      DENY_COMMERCIAL_WARRANTY_DECISION: 'Decisión comercial de garantía denegada',
      SEND_COMMENT: 'Comentario añadido',
      REOPEN_REPORT: 'Trabajo editado - Reabrir informe',
      AWAITING_EQUIPMENT_STATUS_SET: 'Estatus editado - En espera de equipo (realizado)',
      AWAITING_EQUIPMENT_STATUS_RESET: 'Estatus editado - En espera de equipo (no realizado)',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: 'Estatus editado- Equipos receieved con documentación (realizado)',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: 'Estatus editado- Equipos receieved con documentación (no realizado)',
      JOB_RELEASED_STATUS_SET: 'Estatus editado - Trabajo liberado (realizado)',
      JOB_RELEASED_STATUS_RESET: 'Estatus editado - Trabajo liberado (no realizado)',
      PRODUCT_EVALUATION_STATUS_SET: 'Estatus editado - Evaluación del producto (realizado)',
      PRODUCT_EVALUATION_STATUS_RESET: 'Estatus editado - Evaluación del producto (no realizado)',
      PRODUCT_INVESTIGATION_STATUS_SET: 'Estatus editado -Investigación del Producto (realizado)',
      PRODUCT_INVESTIGATION_STATUS_RESET: 'Estatus editado -Investigación del Producto (no realizado)',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: 'Estatus editado - Desmantelado y descontaminado (realizado)',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: 'Estatus editado - Desmantelado y descontaminado (no realizado)',
      BUILT_AND_TESTED_STATUS_SET: 'Estatus editado - Montado y probado (realizado)',
      BUILT_AND_TESTED_STATUS_RESET: 'Estatus editado - Montado y probado (no realizado)',
      SHIPPED_STATUS_SET: 'Estatus editado - Enviado(realizado)',
      SHIPPED_STATUS_RESET: 'Estatus editado - Enviado (no realizado)',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: 'Estatus editado- Decisión técnica y comercial (realizado)',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: 'Estatus editado- Decisión técnica y comercial (no realizado)',
      FINAL_REPORT_RELEASED_STATUS_SET: 'Estatus editado - Informe final liberado (realizado)',
      FINAL_REPORT_RELEASED_STATUS_RESET: 'Estatus editado - Informe final liberado(no realizado)',
      CLOSED_STATUS_SET: 'Estatus editado - Cerrado (realizado)',
      CLOSED_STATUS_RESET: 'Estatus editado - Cerrado (no realizado)',
      CUSTOMER_HOLD_STATUS_SET: 'Estatus editado - Retención de cliente (realizado)',
      CUSTOMER_HOLD_STATUS_RESET: 'Estatus editado - Retención de cliente (no realizado)',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: 'Categoría de decisión tecnica editada',
      GENERATE_ALERT: 'Alerta generada',
      INITIAL_WARRANTY_CODE_EDITED: 'Código de garantía inicial modificado',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision ES',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision ES',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision ES',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision ES',
      CHOOSE_RELEASE_METHOD: 'Chose release method ES',
    },
    TechnicalWarranty: {
      ACCEPTED: 'Aceptado',
      DENIED: 'Denegado',
      AGREE: 'De acuerdo',
      DISAGREE: 'En desacuerdo',
      MANUFACTURING: 'Fabricación',
      DESIGN: 'Diseño',
      VENDOR: 'Vendedor',
      PROCESS: 'Proceso',
      INHOUSE_REPAIR: 'Reparación en casa',
      FIELD_SERVICE_REPAIR: 'Reparación en servicio de campo',
      REFURBISHED_MATERIAL: 'Refurbished material (service division)',
      NO_FAULT_FOUND: 'No se han encontrado fallos',
      WARRANTY_EXPIRED: 'Garantía ha expirada',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Garantía ha expirada - No se han encontrado fallos',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Garantía ha expirada - Causado por el cliente',
      WARRANTY_EXPIRED_OTHER: 'Garantía ha expirada - Otro',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Garantía ha expirada - Problema de componente (falta Edwards)',
      CUSTOMER_FAULT: 'Causado por el cliente',
      OTHER: 'Otro',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: 'De acuerdo con la decisión técnica',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: 'No estoy de acuerdo con la decisión técnica',
      SPARE_PART: 'Spare part (Service Division) ES',
    },
    CommercialWarranty: {
      CONTRACTUAL_AGREEMENT: 'Acuerdo contractual',
      GOODWILL_ACCEPTED: 'De buena fe aceptada',
      CHARGEABLE_TO_CUSTOMER: 'Con cargo al cliente',
      EXTENDED_WARRANTY: 'Garantía extendida',
      SERVICE_CONTRACT: 'Contrato de servicios',
      OTHER: 'Otro',
      SEMICONDUCTOR: 'Semiconductor',
      SCIENTIFIC: 'Scientific',
      INDUSTRIAL: 'Industrial',
      SEMICONDUCTOR_SERVICE: 'Semiconductor Service',
      VACUUM_TECHNIQUE_SERVICE: 'Vacuum Technique Service',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'Semiconductor Chamber Solutions',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
      SCIENTIFIC_CC: 'Scientific Cooling and Cryo',
      SCIENTIFIC_MI: 'Scientific Measurement and Instrumentation',
      SCIENTIFIC_VG: 'Scientific Vacuum Generation'
    },
    Release: {
      NO_TECHNICAL_TEAM_INVOLVEMENT: 'No  es necesario el involucramiento del equipo técnico',
      GOLDENEYE_UPLINK: 'monitoreo GoldenEye ',
      ON_SITE_PRESENCE: 'Presencia en sitio',
      RETURN_TO_PRODUCT_COMPANY: 'Devolución a  compañía producto ',
      SEND_BACK_PARTS: 'Enviar partes de regreso',
    },
    Forms: {
      fields: {
        basicInformation: 'Información básica',
        customerCenter: 'Centro de Atención al Cliente',
        serviceTechnologyCenter: 'Centro de Tecnología de Servicio',
        reportLevel: 'Nivel de informe',
        initialWarrantyCode: 'Código de garantía inicial',
        technicalDecision: 'Decisión técnica',
        commercialDecision: 'Decisión comercial',
        price: 'Costo',
        jobStatus: 'Estatus del trabajo',
        reportCompletion: 'Finalización de reporte',
        alerts: 'Alertas',
        team: 'Equipo',
        customer: 'Cliente',
        customerContact: 'Contacto del cliente',
        jobDetails: 'Detalles del trabajo',
        jobType: 'Tipo de trabajo',
        serviceProduct: 'Producto de servicio',
        equipment: 'Equipo',
        failure: 'Falla',
        symptom: 'Síntoma',
        address: 'Dirección',
        contactPerson: 'Persona de contacto',
        email: 'Email',
        phone: 'Teléfono',
        customerPurchaseOrderNumber: 'Número de orden de compra del cliente',
        equipmentWarranty: 'Garantía del equipo',
        serviceWarranty: 'Garantía de servicio',
        reportStatus: 'Estado del informe',
        reopen: 'Reabrir',
        releaseJob: 'Liberación de trabajo',
        notifyTeam: 'Notify team ES',
      },
      errors: {
        required: 'Campo requerido',
        tel: 'Por favor ingrese un número de teléfono válido.',
        email: 'Por favor ingrese una dirección de correo electrónico válida.',
        number: 'Sólo se permiten números',
        alphanumeric: 'No se permiten caracteres especiales',
        text: 'Por favor ingrese un valor válido',
        unknown: 'Algo salió mal...',
        belowZero: 'El valor no puede ser inferior a 0.',
        uploadFailed: 'No se pudo cargar',
        maxFileSize: 'El tamaño máximo permitido es',
        maxLength: maxLength => `Max ${maxLength} caracteres permitidos`,
        minLength: minLength => `Porfavor inserte por lo menos ${minLength} caracteres`,
      },
    },
    FaultCodes: {
      fallbackDescription: 'No hay descripción para este código',
      jobTypeDescription: {
        'JT001': 'Descripción para el tipo de trabajo JT001',
        'JT002': 'Descripción para el tipo de  trabajo JT002',
      },
      faultCodeDescription: {
        'FC001': 'Descripción para el código de falla  FC001',
        'FC002': 'Descripción para el código de falla  FC002',
      },
      symptomCodeDescription: {
        'SC001': 'Descripción para el código de síntoma SC001',
        'SC002': 'Descripción para el código de síntoma SC002',
      },
    },
    Progress: {
      title: 'Progreso',
      productReceived: 'Producto recibido',
      productEvaluation: 'Evaluación del producto',
      stripObservation: 'Observación del desamblaje',
      technicalInvestigation: 'Investigación técnica',
      conformityTest: 'Prueba de conformidad',
    },
  },
  Profile: {
    title: 'Perfil',
    name: 'Nombre',
    role: 'Función',
    company: 'Empresa',
    rights: 'Derechos',
    linked: 'Usuario está vinculado a',
  },
  Jobs: {
    title: 'Trabajos',
    filters: 'Filtros',
    myJobs: 'Mis trabajos',
    otherJobs: 'Otros trabajos',
    noJobsToDisplay: 'No hay trabajos para mostrar.',
    pleaseUseTheSearchBar: "Please use the search bar. ES",
    id: 'Id',
    createdAt: 'Creado en',
    status: 'Estatus',
    customer: 'Cliente',
    serialProductNumber: 'No. de  poducto de servicio',
    materialNumber: 'No. de material',
    equipmentSerialNumber: 'No. de serie del equipo',
    customerCenterPlantCode: 'CC',
    serviceTechnologyCenterPlannerGroup: 'STC',
    handledBy: 'Manejado por',
    materialDescription: 'Descripción del material',
    customerName: 'Nombre del cliente',
    receivedDate: 'Fecha de recepción',
    customerCenterName: 'Nombre CC',
    reportLevel: 'Nivel de informe',
    productReceived: 'Producto recibido',
    productEvaluation: 'Evaluación del producto',
    stripObservation: 'Observación del desamblaje',
    technicalInvestigation: 'Investigación técnica',
    conformityTest: 'Prueba de conformidad',
    workFlow: 'Flujo de trabajo',
    analysisFlow: 'Análisis de flujo',
    notificationNumber: 'Número de la notificación',
    serviceOrderNumber: 'Número de orden de servicio',
  },
  Job: {
    editButton: 'Editar',
    progress: 'Progreso',
  },
  Filters: {
    filtersTitle: 'Filtros',
    applyButton: 'Aplicar',
    clearButton: 'Despejar',
    sorting: 'Clasificar',
    sortNew: 'Ordenar mas nueva',
    sortOld: 'Ordenar más antigua',
    date: 'Fecha',
    dateFrom: 'Desde',
    dateTo: 'A',
    reportLevel: 'nivel de informe',
    status: 'Estatus',
    customerNumber: 'Número de cliente',
    customerName: 'Nombre del cliente',
    serviceProductNumber: 'Número de producto Servicio',
    materialNumber: 'Número material',
    equipmentSerialNumber: 'Número de serie del equipo',
    stcPlannerGroup: 'grupo de planificación STC',
    selectstcPlannerGroup: 'Seleccione el grupo de planificación STC',
    CCplant: 'planta de CC',
    selectCCplant: 'Seleccione la planta de CC',
    distributor: 'Distribuidor',
    selectDistributor: 'Seleccionar distribuidor',
    failureAnalysisEngineerNotAssigned: 'No asignado a ingeniero de análisis de fallos',
    openedJobs: 'Trabajos abiertos',
    publishedJobs: 'Trabajos publicados',
    pendingMyApproval: 'Mi aprobación pendiente ',
    notificationNumber: 'Número de notificación',
    unreadMessages: 'Mensajes no leídos',
    serviceOrderNumber: 'Número de orden de servicio',
  },
  AddJob: {
    formSections: {
      title: 'Añadir nuevo trabajo',
      createdAt: 'Fecha de creación',
      button: 'Guardar',
      basicInformation: {
        title: 'Información básica',
        fieldLabels: {
          equipmentSerialNumber: 'Número de serie del equipo',
          serviceTechnologyCenter: 'Centro de Tecnología de Servicio',
          customerCenter: 'Centro de Atención al Cliente',
          reportLevel: 'Nivel de informe',
          initialWarrantyCode: 'Código de garantía inicial',
          customerPurchaseOrderNumber: 'Número de orden de compra del cliente',
          responsibleSalesPerson: 'Persona responsable de ventas',
          customerCenterContactName: 'Contacto del centro de servicio a cliente',
          customerCenterContactEmail: 'correo electrónico del centro de servicio a cliente',
        },
      },
      jobType: {
        title: 'Tipo',
        fieldLabels: {
          jobType: 'Tipo',
          jobTypeDescription: 'Descripción',
        },
      },
      searchMaterialNumber: 'Búsqueda de número de material',
      materialNumber: {
        title: 'Número material',
        fieldLabels: {
          materialNumber: 'Número material',
          materialNumberDescription: 'Descripción',
        },
      },
      serviceProductNumber: {
        title: 'número de producto de Servicio',
        fieldLabels: {
          serviceProductNumber: 'número de producto de Servicio',
          serviceProductNumberDescription: 'Descripción',
        },
      },
      symptomCode: {
        title: 'Códigode  síntoma',
        fieldLabels: {
          scGroups: 'Grupo del código de  Síntoma',
          symptomCode: 'Código síntoma',
          symptomCodeDescription: 'Descripción',
        },
      },
      faultCode: {
        title: 'Código de falla',
        fieldLabels: {
          fcGroups: 'Grupo de códigos de falla',
          faultCode: 'Código de falla',
          faultCodeDescription: 'Descripción',
        },
      },
      customerInformation: {
        title: 'Información del cliente',
        fieldLabels: {
          customerId: 'Identificación del cliente',
          customerName: 'Nombre',
          customerAddress: 'Dirección',
          customerContact: 'Persona de contacto',
          customerEmail: 'Dirección de correo electrónico',
          customerPhone: 'Número de teléfono',
        },
      },
    },
  },
  ImportJob: {
    title: 'Trabajo de importación',
    date: 'Fecha de importación',
    importButton: 'Importar',
    searchTitle: 'Búsqueda de trabajo para importar',
    searchSubtitle: 'mínimo de 5 caracteres, sin ceros a la izquierda',
    searchButton: 'Buscar',
    notificationNumberLabel: 'Número de notificación',
    serviceOrderNumberLabel: 'Número de orden de servicio',
    linkTo: 'Vinculado a',
    openJobsFoundForSerNumber: 'Trabajos abiertos encontrados para este número de serie',
    importJobAsNew: 'Importar trabajo como nuevo',
    jobIsImportedAlready: 'El trabajo ya ha sido importado',
    importing: 'Importing in progress... ES',
    linking: 'Linking in progress... ES',
      columns: {
    sourceId: 'Marca',
    notificationNumber: 'No, de notificación',
    serviceOrderNumber: 'No. de Orden de servicio ',
    serialNumber: 'No. De Serie',
    jobTypeDescription: 'Descripción',
    customerName: 'Nombre del cliente',
    },
  },
  SingleJob: {
    title: 'Trabajo',
    createdAt: 'Creado en',
    modifiedAt: 'Última modificación realizada',
    serviceOrderNumber: 'Número de orden de servicio',
    notificationNumber: 'Número de notificación',
    receivedProduct: 'Producto recibido',
    productEvaluation: 'Evaluación del producto',
    stripObservation: 'Observación del desamblaje',
    technicalInvestigation: 'Investigación técnica',
    conformityTest: 'Prueba de conformidad',
    log: 'Iniciar sesión',
    conversation: 'Conversacion',
    noTechPossibilityParagraph1: 'Este STC  no tiene la capacidad de pruebas para este trabajo.',
    noTechPossibilityParagraph2: 'Por favor, cierre el trabajo y enviar la bomba a otro STC.',
    downloadPictures: 'Descargar imágenes',
    downloadAllPictures: 'Descarga todas las imágenes',
    downloadPicturesFrom: 'Descargar imágenes de',
    downloadInProgressPleaseWait: 'Download in progress... Please wait ES',
  },
  JobSummary: {
    title: 'Resumen de trabajo',
    createdAt: 'Creado en',
    modifiedAt: 'Última modificación realizada ',
    reportLevelDialogTitle: 'Nivel de informe',
    reportLevelDialogContent: 'Establecer el nivel de informe solicitado',
    reportLevelDialogInitialWarrantyCodeLabel: 'Código de garantía inicial',
    approveReportLevelDialogTitle: 'Aprobar la solicitud nivel de informe',
    technicalWarrantyDialogTitle: 'Proponer la decisión técnica',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal ES',
    technicalWarrantyDialogContent: 'Decisión de warranty',
    rateTechnicalDecisionTitle: 'Evaluar decisión técnica',
    rate: 'Evaluar',
    reclassify: 'Reclassify ES',
    rateTechnicalDecisionComment: 'Comentar en la evaluacion de la decisión técnica',
    technicalWarrantyDialogCategory: 'Categoría de garantia',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: 'Aprobar la propuesta técnica de garantía',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: 'Reclasificación  de la categoría de decisión técnica',
    commercialDecisionDialogTitle: 'Hacer la decisión comercial',
    commercialDecisionDialogContent: 'Desición comercial',
    commercialDecisionDialogCategory: 'Categoría comercial',
    approveCommercialDecisionDialogTitle: 'Aprobar  propuesta',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision ES',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision ES',
    editPriceDialogTitle: 'Editar costo',
    editPriceLabel: 'Editar',
    releaseJobDialogTitle: 'Liberar trabajo',
    proposedDate: 'Fecha propuesta',
    releaseJobDialogLabel: 'Elija un método',
    reportStatusDialogTitle: 'Proponer cambio al estatus del informe',
    reportStatusDialogContent: 'Esto generará una solicitud de aprobación del informe.',
    approveReportStatusDialogContent: '¿Seguro que desea volver a abrir este trabajo?',
    approveReportStatusDialogTitle: 'Requisición de aprobación de reporte',
    chooseReleaseJobMethodTitle: 'Elija el método de liberación del trabajo',
    editChosenReleaseJobMethodTitle: 'Editar el método de trabajo de liberación elegido',
    editJobStatusDialogTitle: 'Editar estatus del trabajo',
    editEquipmentSerialNumberDialogTitle: 'Editar número de serie del equipo',
    editEquipmentSerialNumberDialogFieldLabel: 'Número de serie del equipo',
    editMaterialNumberDialogTitle: 'Editar número material ',
    editMaterialNumberDialogFieldLabel: 'Número material',
    editMaterialNumberDialogDescriptionFieldLabel: 'Descripción',
    warrantyStartDialogTitle: 'Editar  fecha de inicio de la garantía',
    warrantyStartDateLabel: 'Fecha de inicio de la garantía',
    warrantyEndDialogTitle: 'Editar fecha de finalización de garantía',
    warrantyEndDateLabel: 'Fecha de finalización de la Garantía ',
    verifyJobDialogTitle: 'Verificar trabajo',
    verifyJobDialogContent: 'Esta acción se bloqueará  el material y el número de equipo para la edición. ¿Esta seguro que los siguientes datos sean correctos?',
    materialNumber: 'Número material',
    equipmentSerialNumber: 'Número de serie del equipo',
    deleteConfirmationDialogTitle: 'Confirmación necesaria',
    deleteConfirmationDialogContent: '¿Seguro que desea eliminar este trabajo?',
    teamDialogTitle: 'Añadir miembro del equipo',
    removeTeamMemberDialogTitle: 'Retire miembro del equipo',
    removeTeamMemberDialogContent: '¿Seguro que desea eliminar a este miembro del equipo?',
    technicalDecisionReason: 'Razón pde la  decisión técnica',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    decisionReason: 'razón de la decisión',
    changeReportLevelReason: 'Motivo para cambiar el nivel del informe',
    commercialDecisionReason: 'razón de la decisión comercial',
    approveReportLevelDialogRequestedLevel: 'Nivel solicitado',
    approveReportLevelDialogPreviousLevel: 'Nivel anterior',
    approveReportLevelDialogInitialWarrantyCode: 'Código de garantía inicial',
    initialWarrantyCode: 'Código de garantía inicial',
    shipToAddress: 'Domicilio de envio',
    partNumbers: 'Números de parte',
    failureReason: 'Razón de la falla',
    symptomReason: 'Razón del indicio',
    chooseMethod: 'Elegir método',
    chosenMethod: 'Método elegido',
    serialNumberMissingPleaseAdd: 'Serial number missing, please add. ES',
    deleteImportedJob: 'Delete imported ES',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? ES',
  },
  LogSection: {
    title: 'Iniciar sesión',
    sib: 'SIB',
    initialWarrantyCode: 'Código de garantía inicial',
  },
  ReportsDialog: {
    title: 'Generar informe',
    confirmButton: 'Generar',
    reportFormat: 'Formato de informe',
    reportTemplate: 'Plantilla de reporte',
  },
  ActionMode: {
    takePicture: 'Toma una foto',
    takeStandardPicture: 'Tomar  imagen estándar',
    takeNonStandardPicture: 'Tomar imagen no estándar',
    lastScreenMessage: 'Usted ha llegado al final de esta sección. Por favor, cierre esta ventana.',
    lastScreenMessageUnsavedAnswers: 'Ha llegado al final de esta sección. Por favor guarde sus respuestas'
  },
  InputFile: {
    special: 'Foto no estándar',
    upload: 'Cargar',
    uploadStandardPicture: 'Subir foto estándar',
    uploadNonStandardPicture: 'Subir una foto no estándar',
    commentPicture: 'Comentario de la imagen',
    confirmButtonText: 'Guardar comentario',
    moveFileModal: {
      title: 'Mover archivo',
      confirmButtonText: 'Mover',
      selectSubsection: 'Seleccionar subsección',
      selectQuestion: 'Seleccionar pregunta',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: 'Mover',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/es.js